import BatteryPix from './BatteryPix';

export default BatteryPix;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/BatteryPix/index.js